"use client"

import { captureException } from "@sentry/nextjs"
import { ErrorPage as ErroPageComponent } from "@/components/error/ErrorPage"

export default function ErrorPage({ error }: { error: Error & { digest?: string } }) {
  captureException(error)
  return <ErroPageComponent />
}
